import {useState} from "react";

const testimonials = [
    {
        body: 'From email marketing and Conversion Rate Optimization, the whole team operates and produces results at a higher level. And they do it with a smile & the highest degree of professionalism to produce exceptional results.',
        name: 'Joe Grace',
        companyName: 'Ancestral Supplements',
        imageUrl:
            'https://ancestralsupplements.com/cdn/shop/files/Logo-White_210x@2x.png?v=1660943305',
    },
    {
        body: 'They are very “hands on” with my account. Easy to reach. Intelligent. Lowered my “click” costs dramatically. Rearranged my priorities. Getting more “click throughs” I’m delighted that I found them. Worth the money!',
        name: 'Don Bruhnke',
        companyName: 'Chicago Watermark',
        imageUrl:
            'https://www.smartsites.com/media/chicago-watermark-logo.png',
    },
    {
        body: 'I very much enjoy working with HerStory! Dylan has been great managing our PPC. Our phones ring off of the hook!',
        name: 'Brandon Browne',
        companyName: 'Mind & Body Health Center',
        imageUrl:
            'https://www.mindandbodygroup.com/wp-content/uploads/logo-mind-body.png',
    },
    {
        body: 'Joan K convinced me that a dedicated Landing Page for Google Ads would help a lot. Her team took the time to get it right and put up with numerous revisions that I requested. Excellent customer service and expertise!',
        name: 'Bill O’Donovan',
        companyName: 'Williamsburg Charter Sails',
        imageUrl:
            'https://williamsburgchartersails.com/wp-content/uploads/2023/12/williamsburg-charter-sails-logo-reversed.png',
    },
    {
        body: 'Our revenue is up 42% since implementing the design, October will be our best month ever by double. I am elated with the job HerStory did. Very effective, I give it a 10 out of 10.',
        name: 'Chad Chancellor',
        companyName: 'Next Move Group',
        imageUrl:
            'https://www.smartsites.com/media/next-move-group-logo-1.png',
    },
    {
        body: 'We are a 100% online business and HerStory keeps giving us new clients!!!! We recommend the company for anybody looking for good quality SEO campaign management.',
        name: 'Fabiana Diaz',
        companyName: 'The Logo Boutique',
        imageUrl:
            'https://thelogoboutique.com/logo-design/wp-content/uploads/2023/02/thelogoboutique-2-1.png',
    },
    {
        body: 'HerStory team went out of their way to understand our mission and tailor their approach to meet our goals. As a result, within only 3 months, our traffic is up by 20% and the quality has improved beyond expectation.',
        name: 'Dr. Mark K. Setton',
        companyName: 'Pursuit of Happiness',
        imageUrl:
            'https://www.smartsites.com/media/pursuit-of-happiness-logo-1-2.png',
    },
    {
        body: 'Working with HerStory has been nothing short of exceptional. Dylan is very detail oriented asking all the appropriate questions, ensuring he had all the information to run a flawless campaign. A pleasure to work with.',
        name: 'Nancy DeFilippis',
        companyName: 'Anko Products',
        imageUrl:
            'https://ankoproducts.com/cdn/shop/files/ANKO_LOGO_4_badbfd93-9eea-4b39-9a45-15ce2fd77251_180x@2x.jpg?v=1718989035',
    },
    {
        body: 'We have used their SEO, CRO, EMAIL, and PPC services for over a year and they have been wonderful. Ash is very prompt to respond, knows her stuff and we feel extra confident with her and the team. They have really elevated our business to another level!',
        name: 'Ashley Kirchner',
        companyName: 'Print Crazee',
        imageUrl:
            'https://printcrazee.com/wp-content/uploads/2021/09/logo.png',
    },
    {
        body: 'Their data-driven efforts have helped us increase many of our KPI\'s, including lead generation, traffic to site, conversion, etc. They have been excellent partners of ours and highly recommend working with them.',
        name: 'Livia Xiao',
        companyName: 'Mes Inc.',
        imageUrl:
            'https://www.smartsites.com/media/mes-inc.-logo.png',
    },
    {
        body: 'To date we have closed multiple leads we received from Google which is the best I\'ve seen from any PPC company I\'ve worked with in the last 10 years. I am very pleased with the results and we continue to get better.',
        name: 'Zachary W. Lezberg',
        companyName: 'The Small Business Expo',
        imageUrl:
            'https://d9hhrg4mnvzow.cloudfront.net/cf.thesmallbusinessexpo.com/exhibit-3/40399a5c-smbx-white-logo_10fo068000000000000000.png',
    },

]

export default function TestimonialView() {
    const [isFullHeight, setIsFullHeight] = useState(false);

    return (
        <div className="bg-white py-24 sm:py-32 dark:bg-gray-900">
            <div className="mx-auto px-6 lg:px-8">
                <div className="mx-auto max-w-2xl text-center">
                    <h2 className="text-base/7 font-semibold text-indigo-600 dark:text-indigo-400">Testimonials</h2>
                    <p className="mt-2 text-4xl font-semibold tracking-tight text-balance text-gray-900 sm:text-5xl dark:text-white">
                        Doing amazing work for amazing people.
                    </p>
                </div>
                <div className="mx-auto mt-16 flow-root max-w-2xl sm:mt-20 lg:mx-0 lg:max-w-none">
                    <div className="-mt-8 sm:-mx-4 sm:columns-2 sm:text-[0] lg:columns-3">
                        {testimonials.slice(0, isFullHeight ? 100 : 6).map((testimonial) => (
                            <div key={testimonial.companyName} className="pt-8 sm:inline-block sm:w-full sm:px-4">
                                <figure className="rounded-2xl bg-gray-50 p-8 text-sm/6 dark:bg-white/2.5">
                                    <blockquote className="text-gray-900 dark:text-gray-100">
                                        <p className="custom-font">{`“${testimonial.body}”`}</p>
                                    </blockquote>
                                    <figcaption className="mt-6 flex items-center gap-x-4">
                                        <img
                                            alt=""
                                            src={testimonial.imageUrl}
                                            className="size-16 rounded-full bg-gray-50 dark:bg-gray-800"
                                        />
                                        <div>
                                            <div className="font-semibold text-gray-900">{testimonial.companyName}</div>
                                            <div className="text-gray-600 dark:text-gray-400">{testimonial.name}</div>
                                        </div>
                                    </figcaption>
                                </figure>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="flex items-center justify-center mt-12">
                    <button
                        type="button"
                        className="rounded-full bg-indigo-600 px-3 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        onClick={() => setIsFullHeight(!isFullHeight)}
                    >
                        {isFullHeight ? "See less" : "See more testimonials"}
                    </button>
                </div>
            </div>
        </div>
    )
}
